import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { autoinject, inject } from '../Utils/AutoInject';
import { CommonAppStore } from '../Utils/CommonAppStore';
import { componentAutoReaction } from '../Utils/MobxTools';

export interface ITitleProps {
    readonly documentTitle?: string;
    readonly className?: string;
}

@autoinject
@observer
export class Title extends React.Component<ITitleProps> {
    public constructor(props: ITitleProps) {
        super(props);

        componentAutoReaction(
            this,
            () => this.documentTitle,
            d => (document.title = d)
        );
    }

    public render() {
        if (!this.commonAppStore.titleContainer) return null;

        if (typeof this.props.children == 'string' || isStringArray(this.props.children)) {
            return ReactDOM.createPortal(
                <div className={'flex-items-center h-100 px-2 ' + this.props.className}>
                    <h5 className="header-title fw-bold mb-0">{this.props.children}</h5>
                </div>,
                this.commonAppStore.titleContainer
            );
        } else {
            return ReactDOM.createPortal(
                <div className={'header-title fw-bold flex-items-center ' + this.props.className}>
                    {this.props.children}
                </div>,
                this.commonAppStore.titleContainer
            );
        }
    }

    @computed
    private get documentTitle() {
        if (this.props.documentTitle) return this.props.documentTitle;
        else if (typeof this.props.children == 'string') return this.props.children;
        else if (isStringArray(this.props.children)) return this.props.children.join('');

        return 'SmartVu®';
    }

    @inject
    private readonly commonAppStore!: CommonAppStore;
}

export function isStringArray(value?: React.ReactNode): value is string[] {
    if (Array.isArray(value)) {
        return value.every(x => typeof x == 'string');
    }
    return false;
}
